
export type SearchUsers500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
